import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import CreateVacancyResponse from 'src/components/responses/CreateVacancyResponse/CreateVacancyResponse.vue';
import SimilarVacanciesSlider from 'src/components/vacancies/SimivarVacanciesSlider/SimilarVacanciesSlider.vue';
import VacancyPage from 'src/components/vacancies/VacancyPage/VacancyPage.vue';

import { initLandingLinksTracking } from 'src/parts/landing_links';

const {
  vacancy,
  placeholder,
  createResponse,
  responses,
  employerData,
  currencies,
  vacancyResult,
  company,
  similar,
  userLogin,
  visitor,
  skillsBanner,
} = getSsrState();
const el = document.querySelector('[data-vacancy-show]');

if (el) {
  const { fields, response, vacancyId, responsesThreshold, responsesLeft } =
    createResponse || {};
  const showResponseSection = !!createResponse || !!placeholder;

  const app = createVueApp({
    provide() {
      return {
        vacancyId: vacancy.id,
        userLogin,
        visitor,
      };
    },
    render(h) {
      return h('div', [
        h(VacancyPage, {
          props: {
            vacancy,
            responses,
            createResponse,
            placeholder,
            employerData,
            vacancyResult,
            company,
          },
        }),

        ...(showResponseSection
          ? [
              h(CreateVacancyResponse, {
                props: {
                  placeholder,
                  fields,
                  response,
                  vacancyId,
                  responsesThreshold,
                  responsesLeft,
                  currencies,
                  skillsBanner,
                },
              }),
            ]
          : []),

        ...(similar.length
          ? [
              h(SimilarVacanciesSlider, {
                class: 'mq-mobile-only',
                props: {
                  vacancies: similar,
                },
              }),
            ]
          : []),
      ]);
    },
  });

  app.$mount(el);
}

initLandingLinksTracking();
